// extracted by mini-css-extract-plugin
module.exports = {"devtool":"fold_devtool__XyyJH","icon":"fold_icon__9ObKf","open":"fold_open__3rA9j"};